import { render, staticRenderFns } from "./scoText.vue?vue&type=template&id=dff74a9e&scoped=true&"
import script from "./scoText.vue?vue&type=script&lang=js&"
export * from "./scoText.vue?vue&type=script&lang=js&"
import style0 from "./scoText.vue?vue&type=style&index=0&id=dff74a9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff74a9e",
  null
  
)

export default component.exports